module.exports = __webpack_public_path__ + "img/1_custum-sp.e0ce1ee3.jpg";